import { NON_DIGIT_CHARS } from '@access-cms/shared-constants';

/**
 * Normalize a U.S. phone number to digits, removing a leading country code
 * when the supplied value contains exactly 11 digits.
 */
export function normalizeUsPhoneNumber(value: string): string {
  const digits = value.replace(NON_DIGIT_CHARS, '');

  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
}

/** Format a normalized or externally formatted U.S. phone number for display. */
export function formatUsPhoneNumber(value: string): string {
  const digits = normalizeUsPhoneNumber(value);

  if (digits.length === 0) return '';
  if (digits.length < 3) return `(${digits}`;
  if (digits.length === 3) return `(${digits})`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
